const setFilterButtons = () => {
    if(document.querySelector('.kirinus-job-openings-overview-filter')){
        let filter = document.querySelector('.kirinus-job-openings-overview-filter');
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let linkField = params.berufsfeld;
        let linkLocation = params.standort;
        if(linkField !== null || linkLocation !== null){
            if(linkField !== null){
                filter.setAttribute('data-has-active-filters', linkField) ;
                let linkFieldButton = document.querySelector(`[data-filter="${linkField}"]`);
                if(linkFieldButton) linkFieldButton.classList.add('btn-kirinus-filter__active');
            }
            if(linkLocation !== null){
                filter.setAttribute('data-has-active-location-filters', linkLocation);
                let linkLocationButton = document.querySelector(`[data-filter="${linkLocation}"]`);
                if(linkLocationButton) linkLocationButton.classList.add('btn-kirinus-filter__active');
            }
            filter.scrollIntoView({
                behavior: "smooth"
            });

        }
        if(document.querySelector('.btn-kirinus-filter')){
            const checkActiveFilters = () => {

                let filterData = filter.getAttribute('data-has-active-filters');
                let filterLocationData = filter.getAttribute('data-has-active-location-filters');
                let allJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry');
                let allActiveJobs = [];
                let countActiveJobs = 0;

                if(allJobs.length > 0){
                    if((filterData === '' && filterLocationData === '') || filterData === undefined){
                        allJobs.forEach((job, index) => {
                            if(job !== undefined){
                                job.classList.remove('kirinus-job-openings-overview-list-entry__active_last');

                                if (document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                    job.classList.remove('kirinus-job-openings-overview-list-entry__active');
                                    let showJobsCount = document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs');
                                    let currentShowJobs = document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-active-jobs');

                                    if (currentShowJobs) {
                                        showJobsCount = currentShowJobs;
                                    }

                                    if (countActiveJobs < parseInt(showJobsCount)) {
                                        ++countActiveJobs;

                                        job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                        allActiveJobs.push(job);

                                    }
                                } else {
                                    job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                }

                            }
                        })
                    }
                    else{
                        let filterDataArray = filterData.split(',');
                        let filterDataLocationArray = filterLocationData.split(',');
                        let currentActiveJobs = document.querySelectorAll('.kirinus-job-openings-overview-list-entry__active').length;
                        let loadJobsAttr = document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-show-jobs');
                        let countActiveJobs = 0;

                        allJobs.forEach((job, index) => {
                            if(job !== undefined){
                                job.classList.remove('kirinus-job-openings-overview-list-entry__active');
                                job.classList.remove('kirinus-job-openings-overview-list-entry__active_last');
                                let jobFilterProps = job.getAttribute('data-has-filters');
                                let jobFilterPropsArray = jobFilterProps.split(',');
                                let commonProps = jobFilterPropsArray.filter(word => {
                                    if(filterDataArray.includes(word)) return word
                                })
                                let inLocation = true;
                                let commonLocationArray = [];

                                if(filterLocationData !== '' || filterLocationData === undefined){
                                    commonLocationArray = jobFilterPropsArray.filter(word => {
                                        if(filterDataLocationArray.includes(word)) return word
                                    })
                                    if(!commonLocationArray.length > 0) inLocation = false;
                                }

                                let activeFilters = document.querySelectorAll('.kirinus-job-openings-overview-filter__wrapper .btn-kirinus-filter__active').length;

                                if (activeFilters >= 2 && document.querySelector('.kirinus-job-openings-overview-filter').getAttribute('data-search-mode') === 'and') {

                                    let second_array = job.getAttribute('data-has-filters').split(',');
                                    let first_array  = document.querySelector('.kirinus-job-openings-overview-filter').getAttribute('data-and-mode').split(',');

                                    const result = first_array.every(f => second_array.includes(f))

                                    if (job.getAttribute('data-has-filters').split(',').sort().toString() == document.querySelector('.kirinus-job-openings-overview-filter').getAttribute('data-and-mode').split(',').sort().toString() || result === true) {
                                        job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                        allActiveJobs.push(job);
                                    } else {
                                        job.classList.remove('kirinus-job-openings-overview-list-entry__active');
                                    }
                                } else if(commonLocationArray.length > 0 && commonProps.length > 0){
                                    if (currentActiveJobs === 0) {
                                        if (document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                            if (countActiveJobs < document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs')) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                                allActiveJobs.push(job);
                                            }
                                        } else {
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            allActiveJobs.push(job);
                                        }
                                    } else if (loadJobsAttr != null || countActiveJobs < currentActiveJobs || !document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                        if (loadJobsAttr != null) {
                                            if (countActiveJobs < parseInt(loadJobsAttr)) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            }
                                        } else {
                                            ++countActiveJobs;
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                        }

                                        allActiveJobs.push(job);

                                    }
                                } else if(commonLocationArray.length > 0 && filterData === '' ){
                                    if (currentActiveJobs === 0) {
                                        if (document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                            if (countActiveJobs < document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs')) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                                allActiveJobs.push(job);
                                            }
                                        } else {
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            allActiveJobs.push(job);
                                        }
                                    } else if (loadJobsAttr != null || countActiveJobs < currentActiveJobs || !document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                        if (loadJobsAttr != null) {
                                            if (countActiveJobs < parseInt(loadJobsAttr)) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            }
                                        } else {
                                            ++countActiveJobs;
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                        }

                                        allActiveJobs.push(job);

                                    }
                                } else if(commonProps.length > 0 && filterLocationData === ''){
                                    if (currentActiveJobs === 0) {
                                        if (document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                            if (countActiveJobs < document.querySelector('.kirinus-job-openings-overview-list').getAttribute('data-load-jobs')) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                                allActiveJobs.push(job);
                                            }
                                        } else {
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            allActiveJobs.push(job);
                                        }
                                    } else if (loadJobsAttr != null || countActiveJobs < currentActiveJobs || !document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                                        if (loadJobsAttr != null) {
                                            if (countActiveJobs < parseInt(loadJobsAttr)) {
                                                ++countActiveJobs;
                                                job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                            }
                                        } else {
                                            ++countActiveJobs;
                                            job.classList.add('kirinus-job-openings-overview-list-entry__active');
                                        }

                                        allActiveJobs.push(job);
                                    }
                                }
                            }
                        })

                        if (countActiveJobs === allActiveJobs.length) {
                            if (document.querySelector('.kirinus-load-more-jobs')) {
                                document.querySelector('.kirinus-load-more-jobs').classList.add('d-none');
                            }
                        } else {
                            if (document.querySelector('.kirinus-load-more-jobs')) {
                                document.querySelector('.kirinus-load-more-jobs').classList.remove('d-none');
                            }
                        }

                    }
                    document.querySelectorAll('.kirinus-job-openings-overview-list-entry__active').forEach(
                        function(item, index, array) {
                            if (index === array.length - 1) {
                                item.classList.add('kirinus-job-openings-overview-list-entry__active_last');
                            }
                        }
                    );
                }
            }

            if (!document.querySelector('.kirinus-job-openings-overview-list').hasAttribute('data-load-jobs')) {
                checkActiveFilters();
            }

            document.addEventListener('click', ev => {
                if(ev.target.closest('.btn-kirinus-filter')){
                    let button = ev.target.closest('.btn-kirinus-filter');
                    button.classList.toggle('btn-kirinus-filter__active');
                    checkActive();

                    if (ev.target.closest('ul').querySelectorAll('input:checked').length >= 1) {
                        ev.target.closest('ul').previousElementSibling.classList.add('is-selected');
                    } else {
                        ev.target.closest('ul').previousElementSibling.classList.remove('is-selected');
                    }

                    const countSelectedInput = document.querySelectorAll('.kirinus-job-openings-overview-filter__wrapper input:checked').length;

                    if (countSelectedInput >= 1) {
                        document.querySelector('.btn-reset').innerText = 'Filter entfernen';
                        document.querySelector('.btn-reset').classList.add('btn-normal');
                    } else {
                        document.querySelector('.btn-reset').innerText = 'Alle Stellenangebote';
                        document.querySelector('.btn-reset').classList.remove('btn-normal');
                    }
                }
            })

            const checkActive = () =>{
                let allButtons = document.querySelectorAll('.btn-kirinus-filter');
                let filter = document.querySelector('.kirinus-job-openings-overview-filter');
                let filterData = filter.getAttribute('data-has-active-filters');
                let filterLocationData = filter.getAttribute('data-has-active-location-filters');
                let filterDataLocationArray = filterLocationData.split(',');
                let filterDataArray = filterData.split(',');
                let filterAndArray = [];
                if(filterData === '') filterDataArray = [];

                allButtons.forEach(button => {
                    if(button.classList.contains('btn-kirinus-filter__active')){
                        let filterAttr = button.getAttribute('data-filter');
                        let filterAttrType = button.getAttribute('data-filter-type');

                        if (document.querySelector('.kirinus-job-openings-overview-filter').getAttribute('data-search-mode') === 'and') {
                            filterAndArray.push(filterAttr);
                        }

                        if(filterAttrType === 'location') {
                            if(!filterDataLocationArray.includes(filterAttr)){
                                filterDataLocationArray.push(filterAttr);
                            }
                        } else if(filterAttrType === 'visit') {
                            if(!filterDataLocationArray.includes(filterAttr)){
                                filterDataLocationArray.push(filterAttr);
                            }
                        } else{
                            if(!filterDataArray.includes(filterAttr)){
                                filterDataArray.push(filterAttr);
                            }
                        }
                    }else {
                        let filterAttr = button.getAttribute('data-filter');
                        let filterAttrType = button.getAttribute('data-filter-type');
                        if(filterAttrType === 'location'){
                            if(filterDataLocationArray.includes(filterAttr)){
                                let index = filterDataLocationArray.indexOf(filterAttr)
                                filterDataLocationArray.splice(index, 1);
                            }
                        } else if(filterAttrType === 'visit'){
                            if(filterDataLocationArray.includes(filterAttr)){
                                let index = filterDataLocationArray.indexOf(filterAttr)
                                filterDataLocationArray.splice(index, 1);
                            }
                        } else{
                            if(filterDataArray.includes(filterAttr)){
                                let index = filterDataArray.indexOf(filterAttr)
                                filterDataArray.splice(index, 1);
                            }
                        }
                    }
                })

                filter.setAttribute('data-has-active-filters', filterDataArray.join(','));
                filter.setAttribute('data-has-active-location-filters', filterDataLocationArray.join(','));

                if (document.querySelector('.kirinus-job-openings-overview-filter').getAttribute('data-search-mode') === 'and') {
                    filter.setAttribute('data-and-mode', filterAndArray.join(','));
                }

                checkActiveFilters();

                if (document.querySelectorAll('.btn-kirinus-filter:checked').length === 0) {
                    if (document.querySelector('.kirinus-load-more-jobs')) {
                        document.querySelector('.kirinus-load-more-jobs').classList.remove('d-none');
                    }
                }
            }

            document.querySelector('.btn-reset').addEventListener("click", function(e) {
                clearFilter();
            });
            const clearFilter = () => {
                let allButtons = document.querySelectorAll('.btn-kirinus-filter');
                // let filterText = document.querySelector('.kirinus-job-openings-overview-filter--mobile-button-result-count--wrapper');
                let filter = document.querySelector('.kirinus-job-openings-overview-filter');
                let filterData = filter.getAttribute('data-has-active-filters');
                let filterDataArray = filterData.split(',');
                let jobFilterWrapper = document.querySelector('.kirinus-job-openings-overview-filter__wrapper');
                let jobFilterElements = jobFilterWrapper.querySelectorAll('.btn');

                document.querySelector('.btn-reset').classList.remove('btn-normal');
                document.querySelector('.btn-reset').innerText = 'Alle Stellenangebote';

                if (document.querySelector('.kirinus-load-more-jobs')) {
                    document.querySelector('.kirinus-load-more-jobs').classList.remove('d-none');
                }

                for (let x of jobFilterElements) {
                    x.classList.remove('is-active');
                    x.classList.remove('is-selected');
                }

                if(filterData === '') filterDataArray = [];
                allButtons.forEach(button => {
                    if(button.classList.contains('btn-kirinus-filter__active')){
                        button.classList.remove('btn-kirinus-filter__active');
                        button.checked = false;
                        let filterAttr = button.getAttribute('data-filter');
                        if(filterDataArray.includes(filterAttr)){
                            let index = filterDataArray.indexOf(filterAttr)
                            filterDataArray.splice(index, 1);
                        }
                    }
                })
                filter.setAttribute('data-has-active-filters', '');
                filter.setAttribute('data-has-active-location-filters', '');
                if(filter.hasAttribute('data-and-mode')) {
                    filter.setAttribute('data-and-mode', '');
                }
                checkActiveFilters();
            }

            const getcurrentActiveFilter = () => {
                let activeFilter = [];
                document.querySelectorAll('.kirinus-job-openings-overview-list-entry').forEach(function (item){
                    let getFilter = item.getAttribute('data-has-filters');

                    getFilter.split(',').forEach(function (value) {
                        if (!activeFilter.includes(value)) {
                            activeFilter.push(value);
                        }
                    })
                });

                document.querySelectorAll('.kirinus-job-openings-overview-filter__wrapper ul input').forEach(function (item){
                    let currentFilter = item.getAttribute('data-filter');

                    if (!activeFilter.includes(currentFilter)) {
                        item.closest('.form-check').classList.add('btn-kirinus-filter--disabled');
                    }
                });
            }

            window.addEventListener('load', () =>{
                getcurrentActiveFilter();
            })


        }
    }

}
export default setFilterButtons;
